export default function() {
    
    var inputs = document.getElementsByClassName("freeform-input");
    for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("focus", function(e) {
            e.currentTarget.parentElement
            .querySelector(".freeform-label")
            .classList.add("active");
        });
        inputs[i].addEventListener("blur", function(e) {
            if (e.currentTarget.value == "") {
            e.currentTarget.parentElement
                .querySelector(".freeform-label")
                .classList.remove("active");
            }
        });
    }
    
    const textarea = document.querySelector("textarea");
    if (textarea) {
        textarea.addEventListener("input", function() {
            textarea.style.height = "60px";
            textarea.style.height = textarea.scrollHeight + "px";
        });
    }

    // find every form and add event handler
    var allForms = Array.from(document.querySelectorAll(".form"));
    
    allForms.forEach(function(frm, idx) {

        frm.addEventListener('freeform-ready', function(event) {
			const freeform = event.target.freeform;
			freeform.addOnSuccessfulAjaxSubmit((evt, form, response) => {
				var parent = frm.parentNode;
				var msg = parent.querySelector(".success-message");
				msg.style.display = "block";
				parent.removeChild(frm);
			});
	
			freeform.addOnFailedAjaxSubmit(function(event, form, response) {
				var errors = response.errors;
			});
		});

    });

}
  